import React from 'react';

export type ViewMode = 'grid' | 'list' | 'map';

interface ListingsViewToggleProps {
  currentView: ViewMode;
  localStorageKey: string;
  onViewChange: (view: ViewMode, localStorageKey: string) => void;
  viewConfigs: {
    mode: ViewMode;
    label: string;
    icon: React.ElementType;
    ariaLabel: string;
  }[];
}

const ListingsViewToggle: React.FC<ListingsViewToggleProps> = ({
  currentView,
  onViewChange,
  localStorageKey,
  viewConfigs
}) => {
  return (
    <div className="flex flex-col xl:flex-row gap-4 md:items-center w-full xl:w-auto">
      <div className="flex w-full xl:w-auto justify-between md:justify-start rounded-md border border-gray-200 dark:border-gray-300 bg-white dark:bg-gray-800 p-1">
        {viewConfigs.map(({ mode, label, icon: Icon, ariaLabel }) => (
          <button
            key={mode}
            onClick={() => onViewChange(mode, localStorageKey)}
            className={
              `flex-1 xl:flex-none inline-flex items-center justify-center rounded-md px-2 xl:px-3 sm:py-1 py-2 text-xs sm:text-sm font-medium transition-all 
              ${currentView === mode
              ? 'bg-blue-100 dark:bg-blue-900 text-blue-700 dark:text-blue-300 shadow-sm'
              : 'text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-200 hover:bg-gray-50 dark:hover:bg-gray-700'
              }`}
            aria-label={ariaLabel}
            aria-pressed={currentView === mode}
          >
            <Icon className="h-4 w-4 mr-1 sm:mr-2" />
            <span>{label}</span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default ListingsViewToggle;
